@if(this.solicitud.metadata.Formulario){
  <mat-accordion class="w-full">
    @for (bloque of bloquesGenerales; track $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="flex items-center"> {{ bloque }}
            @if (solicitud.metadata.Formulario[bloque].Pasos.Estado === 2) {
              <mat-icon svgIcon="check_circle" class="icon-size-4 ml-2" [ngStyle]="{'color': 'green'}"></mat-icon>
            }
        
            @if (solicitud.metadata.Formulario[bloque].Pasos.Estado === 1) {
                    <mat-icon svgIcon="cancel" class="icon-size-4 ml-2" [ngStyle]="{'color': 'red'}"></mat-icon>
            }  
          </mat-panel-title>
        </mat-expansion-panel-header>
  
        <div class="flex flex-row items-center justify-end">
          <button (click)="aceptarBloqueInformacion(bloque)" [disabled]="solicitud.metadata.Formulario[bloque].Pasos.Estado === 2">
            <mat-icon svgIcon="check_circle" [ngStyle]="{'color': solicitud.metadata.Formulario[bloque].Pasos.Estado === 0 ? 'gray' : solicitud.metadata.Formulario[bloque].Pasos.Estado === 2 ? 'green' : 'gray'}">
            </mat-icon>
          </button>
          
          <button (click)="rechazarBloqueInformacion(bloque)" [disabled]="solicitud.metadata.Formulario[bloque].Pasos.Estado === 1">
              <mat-icon svgIcon="cancel" [ngStyle]="{'color': solicitud.metadata.Formulario[bloque].Pasos.Estado === 0 ? 'gray' : solicitud.metadata.Formulario[bloque].Pasos.Estado === 1 ? 'red' : 'gray'}"></mat-icon>
          </button>
        </div>

        <!-- Dentro del bloque principal -->
         @for(sub of getBloquesPlanoYSubbloques(solicitud.metadata.Formulario[bloque]); track $index){
        <div class="">
            
            @if(!exludelabel(sub.label)){
                <div class="flex justify-between items-center bg-gray-100 p-2">
                  <h3 class="font-bold text-base text-black ">{{ sub.label }}</h3>
                </div>

                <table class="w-full text-sm mt-2" *ngIf="bloque === 'ListadoBienesMuebles'">
                  <tbody>
                    <tr *ngFor="let campo of sub.campos; let i = index">
                      <!-- Solo muestra la imagen en la primera fila -->
                      <td class="p-2 border text-center w-5/12" *ngIf="i === 0" [attr.rowspan]="sub.campos.length">
                        <img [src]="url_base + solicitud.metadata.DatosGenerales.Referencia + '/Imagenes/' +  campo.valor" alt="imagen" class="w-60 h-auto mx-auto" />
                      </td>
                      @if (!exludelabel(campo.clave)) {
                        <td class="border-b w-7/12">
                          <div><strong>{{ campo.clave }}</strong>: {{ campo.valor }}</div>
                        </td>
                      }
                      </tr>
                  </tbody>
                </table>
               
                <table class="w-full text-sm" *ngIf=" bloque != 'ListadoBienesMuebles'">
                  <tr *ngFor="let campo of sub.campos">
                    
                    @if (!exludelabel(campo.clave)) {
                        <td class="border-b text-black font-bold  w-1/3">{{ campo.clave }}</td>
                        <td class="border-b">{{ campo.valor }}</td>
                    }
                  </tr>
                </table>
            }
        </div>}
      </mat-expansion-panel>
    }
  </mat-accordion>
}

@if(!this.solicitud.metadata.Formulario){
  <div class="flex items-center justify-center h-64">
    <div class="text-2xl font-medium text-gray-400">No hay Detalles de la solicitud</div>
  </div>

}
  
  